if (document.getElementById("guideapp")) {
	const dlnGuide = new Vue({
		el: "#guideapp",
		data: {
			list: [],
			guidesearchterm: null,
			maxLimit: 100,
			guidefilters: {
				category: null,
				types: null,
				location: null,
				locSub: null,
				recType: null,
			},
			hovImg: null,
		},
		mounted() {
			if (typeof card_data !== "undefined") {
				this.list = card_data;
			}

			let urlCat = new URL(location.href).searchParams.get(
				"guidecategory"
			);
			if (urlCat) {
				this.guidefilters.category = urlCat.replace("&amp;", "&");
			}
			let urlTypes = new URL(location.href).searchParams.get(
				"guidetypes"
			);
			if (urlTypes) {
				this.guidefilters.types = urlTypes;
			}

			let urlLoc = new URL(location.href).searchParams.get(
				"guidelocation"
			);
			if (urlLoc) {
				this.guidefilters.location = urlLoc;
			}

			let urlLocSub = new URL(location.href).searchParams.get("locSub");
			if (urlLocSub) {
				this.guidefilters.locSub = urlLocSub;
			}

			let urlRecType = new URL(location.href).searchParams.get("recType");
			if (urlRecType) {
				this.guidefilters.recType = urlRecType;
			}

			let urlSearchTerm = new URL(location.href).searchParams.get(
				"search-term"
			);
			if (urlSearchTerm) {
				this.guidesearchterm = urlSearchTerm;
			}

			// $(".flickity-enabled").each(function () {
			// 	// console.log($(this));
			// 	var scopeThis = $(this);
			// 	setTimeout(function () {
			// 		scopeThis.flickity("resize");
			// 	}, 1000);
			// });

			if ($(".guide-featured-terms").hasClass("guide-featured-terms")) {
				const slider = document.querySelector(".guide-featured-terms");
				let isDown = false;
				let startX;
				let scrollLeft;

				slider.addEventListener("mousedown", (e) => {
					isDown = true;
					slider.classList.add("active");
					startX = e.pageX - slider.offsetLeft;
					scrollLeft = slider.scrollLeft;
				});
				slider.addEventListener("mouseleave", () => {
					isDown = false;
					slider.classList.remove("active");
				});
				slider.addEventListener("mouseup", () => {
					isDown = false;
					slider.classList.remove("active");
				});
				slider.addEventListener("mousemove", (e) => {
					if (!isDown) return;
					e.preventDefault();
					const x = e.pageX - slider.offsetLeft;
					const walk = x - startX;
					slider.scrollLeft = scrollLeft - walk;
				});
			}
		},
		methods: {
			toggleFilter: function (toggleType, toggleVal) {
				let filterSet = this.guidefilters.location;
				if (toggleType === "cat") {
					this.guidefilters.category =
						this.guidefilters.category === toggleVal
							? null
							: toggleVal;
					this.guidefilters.types = null;
				} else if (toggleType === "types") {
					this.guidefilters.types =
						this.guidefilters.types === toggleVal
							? null
							: toggleVal;
				} else if (toggleType === "locSub") {
					this.guidefilters.locSub =
						this.guidefilters.locSub === toggleVal
							? null
							: toggleVal;
				} else if (toggleType === "recType") {
					this.guidefilters.recType =
						this.guidefilters.recType === toggleVal
							? null
							: toggleVal;
				} else {
					this.guidefilters.location =
						this.guidefilters.location === toggleVal
							? null
							: toggleVal;
					this.guidefilters.locSub = "";
				}
			},
			filterCatCheck: function (inVal) {
				if (
					this.guidefilters.category &&
					this.guidefilters.category !== ""
				) {
					return this.list.filter(function (card) {
						return (
							card.catf.indexOf(inVal.replace("&", "&amp;")) > -1
						);
					}).length;
				} else {
					return this.filteredGuide.filter(function (card) {
						return (
							card.catf.indexOf(inVal.replace("&", "&amp;")) > -1
						);
					}).length;
				}
			},
			filterLocCheck: function (inVal) {
				return this.filteredGuide.filter(function (card) {
					return card.locf.indexOf(inVal.replace("&", "&amp;")) > -1;
				}).length;
			},
			filterSubLocCheck: function (inVal) {
				return this.filteredGuide.filter(function (card) {
					return card.locf.indexOf(inVal.replace("&", "&amp;")) > -1;
				}).length;
			},
			filterRecTypeCheck: function (inVal) {
				return this.filteredPrep.filter(function (card) {
					return card.rect.indexOf(inVal.replace("&", "&amp;")) > -1;
				}).length;
			},
			filterCheck: function (inVal) {
				return this.filteredGuide.filter(function (card) {
					return card.cat.indexOf(inVal.replace("&", "&amp;")) > -1;
				}).length;
			},
			subfilterCheck: function (inVal) {
				return this.filteredPrep.filter(function (card) {
					// console.log(card.cat);
					return card.cat.indexOf(inVal.replace("&", "&amp;")) > -1;
				}).length;
			},
			adjustedURL: function (inURL) {
				// if (window.location.search === "?theme=dln2022") {
				// 	return inURL + "?theme=dln2022";
				// } else {
				return inURL;
				// }
			},
			getMax: function () {
				if (
					this.guidefilters.category ||
					this.guidefilters.types ||
					this.guidefilters.location ||
					this.guidefilters.locSub ||
					this.guidefilters.recType
				) {
					return 999;
				} else {
					return 99;
				}
			},
		},
		watch: {
			filterURLs: function (newURL) {
				// console.log("Caught you " + newURL);
				// this.updateURL();

				// const url = new URL(window.location);
				// url.searchParams.set("foo", "bar");
				// if (window.location.search.includes("?theme=dln2022")) {
				// 	newURL = newURL + "&theme=dln2022";
				// }
				let finalURL = window.location.pathname + newURL;
				window.history.pushState(newURL, newURL, finalURL);
				// console.log("TODO: Update URL to " + finalURL);
			},
		},
		computed: {
			maxLimit: function () {
				console.log("why no?");
				if (
					this.guidefilters.category ||
					this.guidefilters.types ||
					this.guidefilters.location ||
					this.guidefilters.locSub ||
					this.guidefilters.recType
				) {
					return 999;
				} else {
					return 99;
				}
			},
			filterURLs: function () {
				let tempString = "&filtering=guide";
				if (this.guidefilters.category) {
					tempString =
						tempString +
						"&guidecategory=" +
						this.guidefilters.category.replace("&", "%26");
				}
				if (this.guidefilters.types) {
					tempString =
						tempString +
						"&guidetypes=" +
						this.guidefilters.types.replace("&", "%26");
				}
				if (this.guidefilters.location) {
					tempString =
						tempString +
						"&guidelocation=" +
						this.guidefilters.location.replace("&", "%26");
				}
				if (this.guidefilters.locSub) {
					tempString =
						tempString +
						"&locSub=" +
						this.guidefilters.locSub.replace("&", "%26");
				}
				if (this.guidefilters.recType) {
					tempString =
						tempString +
						"&recType=" +
						this.guidefilters.recType.replace("&", "%26");
				}
				if (
					this.guidefilters.guidesearchterm &&
					this.guidefilters.guidesearchterm !== ""
				) {
					tempString =
						tempString +
						"&guidesearchterm=" +
						this.guidesearchterm.replace("&", "%26");
				}
				let finalString = "?theme=dln2022";
				// if (window.location.href.indexOf("?") > -1) {
				// 	finalString = "&";
				// }
				finalString = finalString + tempString;
				finalString = finalString.replace("?&", "?");
				finalString = finalString.replace("&&", "&");
				return finalString;
			},
			filteredGuide: function () {
				let subData = this.list;
				if (this.guidefilters.category) {
					subData = subData.filter((gI) => {
						return gI.catf.includes(
							this.guidefilters.category.replace("&", "&amp;")
						);
					});
				}
				if (this.guidefilters.types) {
					subData = subData.filter((gI) => {
						return gI.cat.includes(
							this.guidefilters.types.replace("&", "&amp;")
						);
					});
				}
				if (this.guidefilters.location) {
					subData = subData.filter((gI) => {
						return gI.locf.includes(
							this.guidefilters.location.replace("&", "&amp;")
						);
					});
				}
				if (this.guidefilters.locSub) {
					subData = subData.filter((gI) => {
						return gI.locf.includes(
							this.guidefilters.locSub.replace("&", "&amp;")
						);
					});
				}
				if (this.guidefilters.recType) {
					subData = subData.filter((gI) => {
						return gI.rect.includes(
							this.guidefilters.recType.replace("&", "&amp;")
						);
					});
				}
				if (this.guidesearchterm && this.guidesearchterm !== "") {
					subData = subData.filter((gI) => {
						return gI.title
							.toLowerCase()
							.includes(
								this.guidesearchterm
									.toLowerCase()
									.replace("&", "&amp;")
							);
					});
				}
				return subData;
			},
			filteredPrep: function () {
				let subData = this.list;
				if (this.guidefilters.category) {
					subData = subData.filter((gI) => {
						if (this.guidefilters.category.includes("&")) {
							return gI.catf.includes(
								this.guidefilters.category.replace("&", "&amp;")
							);
						} else {
							return gI.catf.includes(this.guidefilters.category);
						}
					});
				}
				return subData;
			},
			filterHasLocation: function () {
				return this.filteredGuide.filter(function (card) {
					return card.locf.length > 3;
				}).length;
			},
			filterHasCatType: function () {
				return this.filteredPrep.filter(function (card) {
					return card.cat.length > 3;
				}).length;
			},
		},
	});
} else {
	// 	app.innerHTML = `
	// <div class="scroll" style="overflow-y: auto; cursor: pointer;">
	// <div style="display: flex;width: 2000px">
	//   Sideways content
	// </div>
	// </div>`;
}

$(".mobile-filter-toggle").on("click", function () {
	$("body").toggleClass("filters-on");
});
$(".sidebar-close").on("click", function () {
	$("body").removeClass("filters-on");
});
